<mat-card class="table-card">
  <mat-card-header class="table-card-header">
    <mat-card-title i18n="component tableau users | titre">
      Utilisateurs
    </mat-card-title>
    <mat-card-actions class="table-card-header-actions">
      <button mat-mini-fab type="button" color="primary" (click)="openCreate()">
        <mat-icon>add</mat-icon>
      </button>
    </mat-card-actions>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <app-table-users
      [users]="result?.data"
      [userMenuContainer]="userMenuContainer"
      (shouldRefresh)="onRefresh()"
    ></app-table-users>
  </mat-card-content>
  <mat-divider></mat-divider>
  <mat-card-footer class="table-card-footer">
    <mat-card-actions align="end">
      <app-table-paginator
        [pageNumber]="result?.page"
        [hasNextPage]="result?.hasNextPage"
        (pageChange)="onPageChange($event)"
      ></app-table-paginator>
    </mat-card-actions>
  </mat-card-footer>
</mat-card>
